import Loading from '../components/Loading/Loading.jsx'
import { Navigate } from 'react-router-dom'
// react中没有路由守卫 自己封装也是根据条件判断 BeforeEnter.jsx
// 导入路由守卫组件 目前只有一个页面不太需要
import BeforeEnter from '../components/BeforeEnter/BeforeEnter'

// 避免上来一次性加载太多组件，导致首页卡顿的问题。
import { lazy, Suspense } from 'react'

// 配置路由表
const routes = [
    // 小麦机器人页面
    {
        path: "/chat",
        component: lazy(() => import('../views/Chat/Chat.jsx')),
        auth: false,
    },
    // 简易版机器人页面
    {
        path: "/enginechat",
        component: lazy(() => import('../views/EngineChat/EngineChat.jsx')),
        auth: false,
    },
    // 默认重定
    {
        path: "/",
        element: <Navigate to="/chat" replace={false} />
    },
]
// 处理路由（递归）
const generateRouter = (routes) => {
    return routes.map(item => {
        if (item.element) {
            return item;
        }
        item.element = (
            <Suspense fallback={<Loading />}>
                {/* 需要权限验证的，加上 BeforeEnter 这个守卫 */}
                {
                    item.auth ?
                        <BeforeEnter>
                            <item.component />
                        </BeforeEnter>
                        : <item.component />
                }
            </Suspense>
        )
        if (item.children) {
            item.children = generateRouter(item.children)
        }
        return item;
    })
}
const Router = generateRouter(routes);

// 处理权限问题（递归）
const getRouteObjByPath = (routes, path) => {
    // 根据 path 返回当前路由对象
    for (const data of routes) {
        if (data.path === path) {
            return data
        }
        if (data.children) {
            const res = getRouteObjByPath(data.children, path)
            if (res) {
                return res;
            }
        }
    }
    return null;
}
const checkAuth = path => {
    return getRouteObjByPath(routes, path);
}

export {
    Router,
    checkAuth
} 